export const ROUTES = {
    homepage: '/',
    survey: 'survey',
    usefulResources: 'strumenti-utili',
    bestPractices: 'buone-pratiche',
    insights: 'analisi',
    results: 'risultati',
    dataWall: 'data-wall',
    privacyPolicy: 'privacy-policy',
};
